import { IStudentInitialState } from "../types";




export const StudentInitialState: IStudentInitialState = {
    student: {
        first_name: '',
        last_name: '',
        middle_name: '',
        phone: '',
        tg: '',
        cost_per_hour: '',
        user_id: -1,
        parent_full_name: '',
        parent_phone: '',
        parent_tg: '',
        work_tg_name: '',
        work_tg_ids: [],
    },
    isLoading: false,
    error: ''
}
